import PostUpdateDataForm from "./post-update-data-form";

export default PostUpdateDataForm;